module.exports = __webpack_public_path__ + "images/category_lp/jewel/new/assessment_achievements/4@2x_541df4e7c32f7150728b203ec8791bde.png";